import { useTranslation } from "react-i18next";

import { getUnits } from "~/api/units";
import {
  CenteredContainer,
  PageWrapper,
  PaginationControls,
  UnitCard,
} from "~/components";
import { usePaginatedQuery, useTableSearchParams } from "~/hooks";
import { Heading, Spinner } from "~/ui";

const PAGE_SIZE = 5;

export const Units = () => {
  const { t } = useTranslation();
  const { currentPage, setCurrentPage } = useTableSearchParams();
  const {
    query: { data, isLoading },
    totalItems,
  } = usePaginatedQuery({
    queryFn: () => getUnits({ page: currentPage, per_page: PAGE_SIZE }),
    queryKey: ["getUnits", { page: currentPage, pageSize: PAGE_SIZE }],
  });

  const units = data?.data;

  return (
    <PageWrapper>
      <Heading>{t("units.units")}</Heading>
      <div className="mt-4 flex h-full flex-col justify-between gap-8 overflow-hidden">
        {isLoading && (
          <CenteredContainer>
            <Spinner />
          </CenteredContainer>
        )}
        {!isLoading && !totalItems && (
          <CenteredContainer>
            <p className="text-lg text-neutral-80">{t("units.no_data")}</p>
          </CenteredContainer>
        )}
        {!isLoading && totalItems && (
          <div className="flex flex-col gap-16">
            <div className="flex flex-col gap-2">
              {units?.map((unit) => <UnitCard key={unit.id} unit={unit} />)}
            </div>
            <PaginationControls
              currentPage={currentPage}
              numPages={Math.ceil((totalItems ?? 0) / PAGE_SIZE)}
              setPage={setCurrentPage}
            />
          </div>
        )}
      </div>
    </PageWrapper>
  );
};
